import { convertToFloat } from '@/utilz';
import { Col, Form, Row } from 'antd';
import { useEffect } from 'react';
import { USER_PREFERENCES } from '../../../../../../../../contants/common';
import useUserPreference from '../../../../../../../../redux/hooks/useUserPreference';
import { formateWithMoment } from '../../../../../../../../utilz/dates';
import FormDatePicker from '../../../../../../../components/Inputs/FormDatePicker';
import FormInput from '../../../../../../../components/Inputs/FormInput';
import HiddenFormInput from '../../../../../../../components/Inputs/HiddenFormInput';
import Paper from '../../../../../../../components/Paper/Paper';
import SaveCancelButtons from '../../../../../../Shipment/components/SaveCancelButtons';
import TMSFiledCard from '../../../../../../common/components/TMSFiledCard';

const OverChargeItemsCard = ({
  editMode = false,
  isLastItem = false,
  shadowVisible = true,
  index = 0,
  noteDetails,
  setEditMode,
  handleCancel,
  handleSubmit,
  handleDelete,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (noteDetails) {
      form.setFieldsValue({
        ...noteDetails,
        billedAmount: convertToFloat(noteDetails.billedAmount),
        paidAmount: convertToFloat(noteDetails.paidAmount),
        correctCharges: convertToFloat(noteDetails.correctCharges),
        overchargeAmount: convertToFloat(noteDetails.overchargeAmount),
        recoveryAmount: convertToFloat(noteDetails.recoveryAmount),
      });
    }
  }, [noteDetails]);

  const shipDate = Form.useWatch('shipDate', form);
  const paidAmount = Form.useWatch('paidAmount', form);
  const correctCharges = Form.useWatch('correctCharges', form);

  useEffect(() => {
    const paidAmountL = paidAmount ? paidAmount : 0;
    const correctChargesL = correctCharges ? correctCharges : 0;
    let diffAmount = 0;
    diffAmount = paidAmountL - correctChargesL;
    form.setFieldValue('overchargeAmount', convertToFloat(diffAmount));
  }, [paidAmount, correctCharges]);

  const userDateFormat = useUserPreference(USER_PREFERENCES.DEFAULT_DATE_FORMAT);

  const convertToFloatAmounts = (fieldName) => () => {
    const value = form.getFieldValue(fieldName);
    form.setFieldValue(fieldName, convertToFloat(value));
  };

  return (
    <Paper className={`border-muted ${!isLastItem ? 'mb-16' : ''} ${shadowVisible ? '' : 'shadow-none'}`}>
      <Form onFinish={(data) => handleSubmit(data, index)} initialValues={noteDetails} form={form}>
        <div className="border-bottom-muted pt-8 pb-10 px-16">
          <Row justify="space-between align-items-center" gutter={15}>
            <Col sm={6}>
              <FormInput
                label="Freight Bill / Pro Number"
                placeholder="Enter Freight Bill / Pro Number"
                margin="mb-0"
                name="proNo"
                editMode={editMode}
                rules={[
                  {
                    required: true,
                    message: 'Please enter Freight Bill / Pro Number',
                  },
                ]}
                maxLength={25}
                tabIndex={(index + 1) * 100 + 1}
              />
            </Col>
            <Col sm={6}>
              {editMode ? (
                <FormDatePicker
                  label="Ship Date"
                  placeholder="Choose ship date"
                  name="shipDate"
                  editMode={editMode}
                  margin="m-0"
                  rules={[
                    {
                      required: true,
                      message: 'Please choose ship date',
                    },
                  ]}
                  tabIndex={(index + 1) * 100 + 2}
                />
              ) : (
                <TMSFiledCard containerClass="fw-600 text-black" title="Ship Date">
                  {formateWithMoment(shipDate, userDateFormat)}
                </TMSFiledCard>
              )}
            </Col>
            <Col className="flex-1">
              <Row justify="end">
                <Col>
                  <SaveCancelButtons
                    editMode={editMode}
                    lightMode={false}
                    setEditMode={(val) => setEditMode(index, val)}
                    handleRemove={handleDelete(index)}
                    isNew={noteDetails.isNew}
                    idSuffix={`product-details-${index + 1}`}
                    isModified
                    onCancel={handleCancel(index, noteDetails.isNew)}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        <div className="px-15 pt-10">
          <Row gutter={15}>
            <Col sm={6}>
              <FormInput
                label="Package Number"
                placeholder="Please enter package number"
                name="packageNumber"
                editMode={editMode}
                maxLength={30}
                tabIndex={(index + 1) * 100 + 3}
              />
              <FormInput
                label="Invoice Number"
                placeholder="Please enter invoice number"
                name="invoiceNumber"
                editMode={editMode}
                maxLength={25}
                tabIndex={(index + 1) * 100 + 4}
              />
            </Col>
            <Col sm={6}>
              <FormInput
                label="Chargeable Weight"
                placeholder="Please enter chargeable weight"
                name="weight"
                editMode={editMode}
                inputType="number"
                tabIndex={(index + 1) * 100 + 5}
              />
              <FormInput
                label="Billed Amount"
                placeholder="Please enter billed amount"
                name="billedAmount"
                editMode={editMode}
                inputType="number"
                tabIndex={(index + 1) * 100 + 6}
                onBlur={convertToFloatAmounts('billedAmount')}
              />
            </Col>
            <Col sm={6}>
              <FormInput
                label="Paid Amount"
                placeholder="Please enter paid amount"
                name="paidAmount"
                editMode={editMode}
                inputType="number"
                tabIndex={(index + 1) * 100 + 7}
                onBlur={convertToFloatAmounts('paidAmount')}
              />
              <FormInput
                label="Correct Charges"
                placeholder="Please enter correct charges"
                name="correctCharges"
                editMode={editMode}
                inputType="number"
                tabIndex={(index + 1) * 100 + 8}
                onBlur={convertToFloatAmounts('correctCharges')}
              />
            </Col>
            <Col sm={6}>
              <FormInput
                label="Overcharge Sum"
                placeholder="Please enter overcharge sum"
                name="overchargeAmount"
                editMode={false}
                inputType="number"
                margin={editMode ? 'mb-30' : 'mb-15'}
              />
              <FormInput
                label="Recovery Sum"
                placeholder="Please enter recovery sum"
                name="recoveryAmount"
                editMode={editMode}
                inputType="number"
                tabIndex={(index + 1) * 100 + 9}
                onBlur={convertToFloatAmounts('recoveryAmount')}
              />
            </Col>
          </Row>
        </div>
        <HiddenFormInput name="sequenceNo" />
        <HiddenFormInput name="shipDate" />
        <HiddenFormInput name="isNew" />
        <HiddenFormInput name="editMode" />
        <HiddenFormInput name="itemID" />
        <HiddenFormInput name="fbOcKey" />
      </Form>
    </Paper>
  );
};

export default OverChargeItemsCard;
